<template>
  <div class="djs" @click="turnVideo" v-if="data">
    <video v-if="data.journalismType === 'video'" :src="data['journalismUrl' + En]" ref="video"></video>
    <img class="img" v-else :src="data['journalismUrl' + En]" alt="">
    <div class="inner" v-if="show">
      <div class="inner-content">
        <div class="small" v-html="data['journalismTitle' + En]"></div>
        <img class="btn" src="https://static.worldaic.com.cn/2024/web/static/images/play-icon.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  name: 'djs',
  data() {
    return {
      show: true,
      data: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    turnVideo() {
      this.$jsAPI('track','homeClick',
          {
            'floor_var': '大会宣传视频',
            'position_var': '1',
            'flowName_var': this.data.journalismTitle.replace(/<br>|<b>|<\/b>/g, ''),
            'industryFirstCate_var': '无',
            'industrySecCate_var': '无',
            'tabName_var': `无`,
          }
      );
      gio('track','homeClick',
          {
            'floor_var': '大会宣传视频',
            'position_var': '1',
            'flowName_var': this.data.journalismTitle.replace(/<br>|<b>|<\/b>/g, ''),
            'industryCate_var': '无',
            'industryFirstCate_var': '无',
            'tabName_var': `无`,
          }
      );

      if (this.$refs.video.paused) {
        this.$refs.video.play()
        this.show = false
      } else {
        this.$refs.video.pause()
        this.show = true
      }
    },
    getData() {
      protal.getJson("home_page_journalism", (data) => {
        this.data = data[0] || null
        console.log(this.data, 11)
      });
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .djs {
    width: 100%;
    height: 10.8rem;
    position: relative;
    z-index: 11;
    cursor: pointer;

    video, .img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .inner {
      position: relative;
      z-index: 1;
      pointer-events: none;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding-bottom: .94rem;
      padding-right: .6rem;
    }

    .small {
      font-size: .64rem;
      font-weight: bold;
      color: #FFFFFF;
      line-height: .92rem;
      text-align: left;
      margin-top: .24rem;
    }

    /deep/ b {
      display: block;
      height: 1rem;
      font-size: 1rem;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 1;
      text-align: left;
      margin-bottom: .2rem;
    }

    .btn {
      display: block;
      width: 1rem;
      height: 1rem;
      margin: .4rem auto 0;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .djs {
    width: 100%;
    height: 4.21rem;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    video, .img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
    
    .inner {
      position: relative;
      z-index: 1;
      pointer-events: none;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    .small {
      font-size: .36rem;
      font-weight: bold;
      color: #FFFFFF;
      line-height: .52rem;
      text-align: left;
      margin-top: .16rem;
    }

    /deep/ b {
      display: block;
      font-size: .72rem;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 1;
      text-align: left;
      margin-top: .08rem;
    }

    .btn {
      display: block;
      width: .8rem;
      height: .8rem;
      margin: .2rem auto 0;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/djs.vue